import PropTypes from 'prop-types';
import React from 'react';
import LinesEllipsisLoose from 'react-lines-ellipsis/lib/loose';
import Cell from './Cell';
const TextCell = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    maxLines = 2,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Cell, props, /*#__PURE__*/React.createElement(LinesEllipsisLoose, {
    component: "div",
    lineHeight: 14 * 1.15,
    maxLine: maxLines,
    text: children
  }));
});
TextCell.propTypes = {
  maxLines: PropTypes.number,
  children: PropTypes.any.isRequired
};
TextCell.displayName = 'TextCell';
export default TextCell;